import { Tag } from 'antd';
import React from 'react';

import { SmartLockAlert, SmartLockAlertSeverity } from '../../../graphql/api/generated';

type SmartLockAlertFragment = Pick<SmartLockAlert, 'type' | 'title' | 'severity'>;

interface ISmartLockAlertTagsProps {
  alerts: SmartLockAlertFragment[];
  tagContainerStyle?: React.CSSProperties;
}

export const SmartLockAlertTags: React.FC<ISmartLockAlertTagsProps> = (props) => {
  const { alerts, tagContainerStyle } = props;

  return (
    <>
      {alerts.map(({ type, title, severity }) => (
        <span key={type} style={tagContainerStyle}>
          <Tag
            style={{ color: 'rgba(0, 0, 0, 0.85)', marginBottom: 5 }}
            color={severity === SmartLockAlertSeverity.HIGH ? 'red' : 'gold'}
          >
            {title}
          </Tag>
        </span>
      ))}
    </>
  );
}
